import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { DEPRECATED_Typography as Typography } from "@jti/ui";
import styles from "./HeaderBlock.module.scss";
export const HeaderBlock = ({ header, text, componentId }) => {
    return (_jsxs("div", { className: styles.border, id: componentId, children: [_jsx("div", { className: styles.header, children: _jsx(Typography, { color: "grey-3", type: "small-title", children: header }) }), _jsx(Typography, { color: "grey-3", type: "text", children: text })] }));
};
//# sourceMappingURL=HeaderBlock.js.map